import { baseApi } from "src/core/api/base";
import { TenantApiDto } from "src/core/types/tenant";

const TENANT_ENDPOINT = "/tenant-service/v1/private/tenantsByIds";

const tenantApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTenantsByIds: builder.query<TenantApiDto[], { tenantIds: string[] }>({
      query: ({ tenantIds }) => {
        const search =
          tenantIds.length > 0
            ? `?${tenantIds.map((id) => `id=${encodeURIComponent(id)}`).join("&")}`
            : "";
        return {
          url: `${TENANT_ENDPOINT}${search}`,
          method: "GET",
        };
      },
      extraOptions: {},
    }),
  }),
});

export const { useGetTenantsByIdsQuery } = tenantApi;
